import { useState } from "react";

export default function ChartExplainAction({
  chartId,
  onExplain,
  explanation,
  source,
  loading,
  disabled = false,
  containerClassName = "absolute top-2 right-2 z-10",
}) {
  const [open, setOpen] = useState(false);
  const sourceLabel =
    source === "gemini" ? "Gemini" : source === "rule_based" ? "Auto-generated" : null;
  const tooltipId = `chart-explain-${chartId}`;

  const handleOpen = () => {
    setOpen(true);
    if (!explanation && !loading && !disabled) onExplain(chartId);
  };

  return (
    <div className={containerClassName} data-export-ignore>
      <div className="relative">
        <button
          type="button"
          onMouseEnter={handleOpen}
          onFocus={handleOpen}
          onMouseLeave={() => setOpen(false)}
          onBlur={() => setOpen(false)}
          disabled={disabled}
          aria-describedby={open ? tooltipId : undefined}
          className="chart-explain-btn h-7 min-w-[1.75rem] px-1.5 rounded-full border text-xs font-bold shadow-sm focus:outline-none focus:ring-2 disabled:opacity-40"
          title="Explain this chart"
        >
          i
        </button>
        {open ? (
          <div
            id={tooltipId}
            className="chart-explain-tooltip absolute right-0 mt-2 w-[22rem] max-w-[85vw] rounded-lg border p-3 text-xs leading-relaxed shadow-xl z-20"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            role="tooltip"
          >
            {loading && !explanation ? (
              <p className="chart-explain-muted">Generating explanation...</p>
            ) : explanation ? (
              <>
                <p>{explanation}</p>
                {sourceLabel ? <p className="chart-explain-muted mt-2 text-[11px]">{sourceLabel}</p> : null}
              </>
            ) : (
              <p className="chart-explain-muted">Hover to load explanation.</p>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
}
